import React, { useState, useEffect } from 'react';
import productsData from '../data/productData.json';
import ProductCard from './ProductCard';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import featuredProductId from '../data/featuredProduct.json';

interface Product {
    id: number;
    title: string;
    thumbnailUrl: string;
    previewMediaUrls: string[];
    description: string;
    version: string;
    datePosted: string;
    dateUpdated: string;
    game: string;
    platforms: string[];
    tags: string[];
}

const RecentUpdatesGroup: React.FC = () => {
    const [products, setProducts] = useState<Product[]>([]);

    useEffect(() => {
        setProducts(productsData);
    }, []);

    // Sorting and filtering logic
    const filteredProducts = productsData
        .sort((a, b) => {
            let valueA: number | string = 0;
            let valueB: number | string = 0;

            // Sort by dateUpdated first (fallback to datePosted if dateUpdated is missing)
            const dateA = a.dateUpdated ? a.dateUpdated : a.datePosted;
            const dateB = b.dateUpdated ? b.dateUpdated : b.datePosted;
            valueA = new Date(dateA).getTime();
            valueB = new Date(dateB).getTime();

            // First sort by the selected field (datePosted or dateUpdated)
            if (valueA !== valueB) {
                return valueA < valueB ? 1 : -1;
            }

            // If the dates are equal, then sort by id as the second criteria
            return b.id - a.id;
        });

    // Remove the featured product if it appears anywhere in the list
    const productsWithoutFeatured = filteredProducts.filter(
        (product) => product.id !== featuredProductId[0].id
    );

    // Take first four results after filtering
    const limitedProducts = productsWithoutFeatured.slice(0, 4);

    return (
        <div className="mt-5">
            <div className="row mb-2">
                <h1 className="col kanit-extrabold">Recent Updates</h1>
                <div className="col-auto my-auto">
                    <Link to="/works" className="btn btn-primary kanit-regular">
                        <FontAwesomeIcon icon={faEllipsis} className="me-2 fa-xl" />
                        View More
                    </Link>
                </div>
            </div>
            <div className="row">
                {limitedProducts.map((product) => (
                    <ProductCard
                        id={product.id}
                        title={product.title}
                        slug={product.slug}
                        description={product.description}
                        thumbnailUrl={product.thumbnailUrl}
                        version={product.version}
                        datePosted={product.datePosted}
                        dateUpdated={product.dateUpdated}
                        game={product.game}
                        tags={product.tags}
                    />
                ))}
            </div>
        </div>
    );
};

export default RecentUpdatesGroup;